import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info",
  role: "alert"
}
const _hoisted_8 = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "form-group form-check" }
const _hoisted_12 = ["onClick", "id", "value", "checked"]
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 4,
  class: "alert alert-info",
  role: "alert"
}

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineDataStreamPage, useAdminConfigurePipelinePropertiesPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineDataStreamsPage',
  setup(__props) {

    document.title = "Configure data streams"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()
    const customDataStreamInput = ref('')

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorDataStreamsQuery,
        useChangeDataStreamCommand,
    } = useAdminConfigurePipelineDataStreamPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const dataStream = computed<string>(() => modelPipelineDetailsQueryV1.value?.DataStream)
    const currentDataStream = computed<string | null>(() => dataStream.value || null)

    const { runConnectorDataStreamsQueryV1, modelConnectorDataStreamsQueryV1 } = useConnectorDataStreamsQuery(connectorId)
    const dataStreams = computed<string[]>(() => modelConnectorDataStreamsQueryV1.value?.DataStreams || [])
    const supportsDataStreams = computed<boolean>(() => modelConnectorDataStreamsQueryV1.value?.SupportsDataStreams || false)
    const dataStreamsError = computed<string | undefined>(() => modelConnectorDataStreamsQueryV1.value?.DataStreamsError)

    const { invokeChangeDataStreamCommandV1, succeedChangeDataStreamCommandV1 } = useChangeDataStreamCommand(id, tid, userId)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

    watch(connectorId, () => {
        runConnectorDataStreamsQueryV1()
    })

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
    })

    watch(succeedChangeDataStreamCommandV1, () => {
        if (succeedChangeDataStreamCommandV1.value) {
            runPipelineDetailsQueryV1()
            // Clear the input after successful submission
            customDataStreamInput.value = ''
        }
    })

    // Initialize the input with the current data stream value when it's loaded
    watch(currentDataStream, (newValue) => {
        if (newValue && !customDataStreamInput.value) {
            customDataStreamInput.value = newValue
        }
    }, { immediate: true })

    function handleChangeDataStreamCommandV1(dataStream: string){
        invokeChangeDataStreamCommandV1({ DataStream: dataStream })
    }

    function handleCustomDataStreamSubmit() {
        const trimmedStream = customDataStreamInput.value.trim()
        if (trimmedStream) {
            invokeChangeDataStreamCommandV1({ DataStream: trimmedStream })
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure data stream", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      (currentDataStream.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Current data stream:", -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(currentDataStream.value), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Available data streams", -1 /* CACHED */)),
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (dataStreamsError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Note:", -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(dataStreamsError.value) + " ", 1 /* TEXT */),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            (supportsDataStreams.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "You can manually enter a data stream name below."))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (dataStreams.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataStreams.value, (ds, i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("input", {
                  onClick: ($event: any) => (handleChangeDataStreamCommandV1(ds)),
                  type: "radio",
                  class: "form-check-input",
                  id: `datastream${i}`,
                  name: "dataStream",
                  value: ds,
                  checked: dataStream.value === ds
                }, null, 8 /* PROPS */, _hoisted_12),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `datastream${i}`
                }, _toDisplayString(ds), 9 /* TEXT, PROPS */, _hoisted_13)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (supportsDataStreams.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("h6", null, _toDisplayString(dataStreams.value.length > 0 ? 'Or enter' : 'Enter') + " a custom data stream name:", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_15, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "customDataStream" }, "Custom data stream", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customDataStreamInput).value = $event)),
                type: "text",
                class: "form-control",
                id: "customDataStream",
                placeholder: "e.g., Sheet1, MyData, etc.",
                onKeyup: _withKeys(handleCustomDataStreamSubmit, ["enter"])
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, customDataStreamInput.value]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("small", { class: "form-text text-muted" }, " Enter a custom data stream name (e.g., Excel sheet name) and click \"Set Custom Stream\" ", -1 /* CACHED */))
            ]),
            _createElementVNode("button", {
              onClick: handleCustomDataStreamSubmit,
              class: "btn btn-primary",
              disabled: !customDataStreamInput.value || customDataStreamInput.value.trim() === ''
            }, " Set Custom Stream ", 8 /* PROPS */, _hoisted_16),
            (customDataStreamInput.value !== currentDataStream.value && currentDataStream.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (customDataStreamInput.value = currentDataStream.value)),
                  class: "btn btn-secondary ml-2"
                }, " Reset to Current "))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (!supportsDataStreams.value && dataStreams.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " This connector does not support multiple data streams. "))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})